import { PrescriptionMedicineCheck } from "../../models/pharmacy/prescription-medicine-check.model";

export class PrescriptionMedicineCheckStruct {
    prescriptionMedicineCheck: PrescriptionMedicineCheck = new PrescriptionMedicineCheck();
    
    prescriptionStatus: number;

    userName: string;
    professionName: string;
    public prescriptionObservationOnBed: string;
    
    public isBeforeActualSchedulingCycle: boolean;
}